<template>
  <el-upload
    class="upload-demo"
    ref="upload"
    :limit="fileQuantityLimit"
    action=""
    :accept="acceptExtensionForComponent"
    :on-change="handleChange"
    :on-remove="handleRemove"
    :auto-upload="false"
    :file-list="fileList"
    :list-type="listType"
    :multiple="fileQuantityLimit > 1 ? true : false"
  >
    >
    <el-button slot="trigger" size="small" type="primary" v-show="fileList.length < fileQuantityLimit">選擇檔案</el-button>
    <div slot="tip" class="el-upload__tip" style="line-height: 1.5rem;">
      <span v-if="acceptExtensionForMessage != ''" style="margin-right: 1rem;">檔案格式必須為{{ acceptExtensionForMessage }}<br /></span>
      <span v-if="limitSizeOfMB !== null && limitSizeOfMB !== undefined">檔案大小不得超過{{ limitSizeOfMB }}MB<br /></span>
      <span v-if="fileQuantityLimit !== null && fileQuantityLimit !== undefined && fileQuantityLimit > 1">單次最多上傳{{ fileQuantityLimit }}張<br /></span>
      <span v-if="pictureSizeRemark !== null && pictureSizeRemark !== undefined">建議尺寸 : {{ pictureSizeRemark }}<br /></span>
    </div>
  </el-upload>
</template>

<script>
export default {
  data() {
    return {
      acceptExtensionForComponent: "", // 給上傳元件用來限制上傳檔名(在選擇檔案視窗會限制副檔名)
      acceptExtensionForMessage: "", // 限定格式的提示字
    };
  },
  props: {
    fileQuantityLimit: Number, // 上傳數量限制
    acceptExtensions: Array, // 可上傳的副檔名陣列
    limitSizeOfMB: Number, // 單一檔案大小限制
    fileList: Array, // fileList同時會利用emit向外更新
    listType: String, // picture or text
    pictureSizeRemark: String, //
  },
  methods: {
    handleChange(file, fileList) {
      let extensionCheck = true;
      // 有限制副檔名的狀態才須驗證
      if (this.acceptExtensions !== null && this.acceptExtensions !== undefined && this.acceptExtensions.length > 0) {
        if (this.acceptExtensions.includes(this.getFileExtension(file.name))) {
          extensionCheck = true;
        } else {
          extensionCheck = false;
        }
      }
      const sizeCheck = this.limitSizeOfMB == null || file.size / 1024 / 1024 < this.limitSizeOfMB;

      if (!extensionCheck) {
        this.$message.error(`檔案格式必須為${this.acceptExtensionForMessage} !`);
        fileList.splice(fileList.length - 1, 1);
      } else if (!sizeCheck) {
        this.$message.error(`檔案大小不得超過${this.limitSizeOfMB}MB!`);
        fileList.splice(fileList.length - 1, 1);
      } else {
        this.$emit("update:fileList", fileList);
      }
    },
    handleRemove(file, fileList) {
      this.$emit("update:fileList", fileList);
    },
    getFileExtension(filename) {
      return /[.]/.exec(filename) ? `.${/[^.]+$/.exec(filename)[0]}`.toLowerCase() : undefined;
    },
  },
  mounted() {
    if (this.acceptExtensions !== null && this.acceptExtensions !== undefined) {
      for (let i = 0; i < this.acceptExtensions.length; i += 1) {
        if (i !== 0) {
          this.acceptExtensionForComponent += ",";
          this.acceptExtensionForMessage += "、";
        }
        const extension = this.acceptExtensions[i];
        this.acceptExtensionForComponent += extension;
        this.acceptExtensionForMessage += extension;
      }
    }
  },
  watch: {
    fileList() {
      if (this.fileList === null || this.fileList === undefined || this.fileList.length === 0) {
        this.$refs.upload.clearFiles(); // 監控prop的filelist被父原件清空時，應該將列表歸0。
      }
    },
  },
};
</script>

<style lang="scss">
// 移除過渡動畫
.el-upload-list__item {
  transition: none !important;
}
</style>
